import React from "react"
import { ModalSeeker, AutocompleteSeeker } from "@ui-seeker/core"
import { TextField, Grid, MenuItem, FormControlLabel, Checkbox } from "@mui/material"
import { AppAntSwitch } from "@components"
import { isOpenCreateSftpUserModal } from "Pages/Admin/ExportConnections/@signals"
import { useCreateSftpUser } from "Pages/Admin/ExportConnections/@hooks"

const FILE_FORMAT_OPTIONS = ["csv", "txt", "xlsx", "json"]
const COMPRESSION_OPTIONS = [
	{ value: "none", label: "Sin comprimir" },
	{ value: "zip", label: "zip" },
	{ value: "gzip", label: "gzip" },
]

export default function CreateSftpUserModal() {
	const {
		username, includeFormatOptions,
		fileFormat, compression,
		company, uid, selectByUser,
		companiesOptions, usersOptions, isLoadingOptions,
		isLoading, onToggleSelectByUser, onSubmit, onClose,
	} = useCreateSftpUser()

	return <ModalSeeker
		title="Create SFTP User"
		isOpen={isOpenCreateSftpUserModal.value}
		controller={onClose}
		successText="Create"
		disableCloseOnSuccess
		successProps={{
			onClick: onSubmit,
			loading: isLoading,
			disabled: !username.value.trim() || isLoading ||
				(includeFormatOptions.value && company.value == null && uid.value == null),
		}}
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<TextField
					fullWidth
					required
					label="SFTP Username"
					value={username.value}
					onChange={e => username.value = e.target.value}
					onKeyDown={e => e.key === "Enter" && onSubmit()}
					autoFocus
					disabled={isLoading}
				/>
			</Grid>
			<Grid item xs={12}>
				<FormControlLabel
					label="Create connection in Price Seeker to export reports"
					control={<Checkbox
						checked={includeFormatOptions.value}
						onChange={e => includeFormatOptions.value = e.target.checked}
						disabled={isLoading}
					/>}
				/>
			</Grid>
			{includeFormatOptions.value && <>
				<Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
					<AppAntSwitch
						falseText="Company"
						trueText="User"
						checked={selectByUser.value}
						onChange={() => onToggleSelectByUser(!selectByUser.value)}
						disabled={isLoading}
					/>
					{!selectByUser.value
						? <AutocompleteSeeker
							label="Company *"
							placeholder="Select a company"
							options={companiesOptions}
							value={company.value}
							onChange={e => company.value = e.target.value ?? null}
							loadingOptions={isLoadingOptions}
							disabled={isLoading}
						/>
						: <AutocompleteSeeker
							label="User *"
							placeholder="Select a user"
							options={usersOptions}
							value={uid.value}
							onChange={e => uid.value = e.target.value ?? null}
							loadingOptions={isLoadingOptions}
							disabled={isLoading}
						/>
					}
				</Grid>
				<Grid item xs={12}>
					<TextField
						select
						fullWidth
						required
						label="File Format"
						value={fileFormat.value}
						onChange={e => fileFormat.value = e.target.value}
						disabled={isLoading}
					>
						{FILE_FORMAT_OPTIONS.map(opt => <MenuItem key={opt} value={opt}>{opt}</MenuItem>)}
					</TextField>
				</Grid>
				<Grid item xs={12}>
					<TextField
						select
						fullWidth
						label="Compression"
						value={compression.value}
						onChange={e => compression.value = e.target.value}
						disabled={isLoading}
					>
						{COMPRESSION_OPTIONS.map(({ value, label }) => <MenuItem key={value} value={value}>{label}</MenuItem>)}
					</TextField>
				</Grid>
			</>}
		</Grid>
	</ModalSeeker>
}